import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const iconEnter = keyframes`
  0% { transform: scale(0.5); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(10, 25, 47, 0.95);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: ${fadeIn} 0.5s ease-in-out;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  color: #c5cdd6;
`;

export const Logo = styled.img`
  width: 150px;
  margin-bottom: 2rem;
`;

export const IconWrapper = styled.div`
  font-size: 3rem;
  color: #FFD700; /* Dourado */
  animation: ${iconEnter} 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
`;

export const LoadingText = styled.p`
  font-size: 1.2rem;
  font-weight: 300;
  letter-spacing: 1px;
`;

export const ProgressBarContainer = styled.div`
  width: 300px;
  height: 8px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  overflow: hidden;
`;

export const ProgressBarFiller = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #FFD700, #F0B90B);
  border-radius: 4px;
  transition: width 1.5s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const ProgressText = styled.span`
  font-size: 0.9rem;
  font-family: 'monospace';
  color: #8892b0;
`;